// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { categoryDetailSubCategoriesStyles } from "@sc/Overrides/Widgets/Category/CategoryDetailSubCategories";
import { xScreen } from "@sc/XDL/Utilities";
import { css } from "styled-components";

categoryDetailSubCategoriesStyles.wrapper = {
    css: css`
        display: flex;
        flex-wrap: wrap;
        gap: 20px;
        ${xScreen("lte", 767)} {
            justify-content: center;
        }
        ${xScreen("lte", "xs")} {
            column-gap: 16px;
        }
    `,
};

categoryDetailSubCategoriesStyles.subCategoryItem = {
    width: [12, 12, 4, 4, 2],
    css: css`
        padding: 0;
    `,
};

categoryDetailSubCategoriesStyles.subCategoryImageItem = {
    width: [2, 2, 12, 12, 12],
    css: css`
        width: 100%;
    `,
};

categoryDetailSubCategoriesStyles.categoryItemStyles = {
    categoryItem: {
        css: css`
            max-width: 149px;
            justify-content: start;

            ${xScreen("lte", "md")} {
                max-width: 169px;
            }
            ${xScreen("lte", "xs")} {
                max-width: 156px;
            }
        `,
    },
    categoryTitle: {
        css: css`
            text-align: center;
        `,
    },
    image: {
        css: css`
            width: 149px;
            height: 149px;
            ${xScreen("lte", "md")} {
                width: 169px;
                height: 169px;
            }
            ${xScreen("lte", "xs")} {
                width: 156px;
                height: 156px;
            }
        `,
    },
};
